import {customElement, property} from "lit/decorators.js";
import {html, LitElement, type TemplateResult} from "lit";
import Styles from "./dropdownOption.lit.scss";
import {dropdownEvent} from "./inputEvents";

@customElement("eop-dropdown-option")
export class EopDropdownOption extends LitElement {

    public static readonly styles = Styles;

    @property()
    public value: string;
    @property()
    public label: string;
    @property({attribute: true, type: Boolean})
    public selected: boolean = false;

    public render(): TemplateResult {
        return html`
            <div @click=${this.sendSelectEvent} class="custom-option">${this.label}</div>`;
    }

    private sendSelectEvent(event: Event): void {
        event.stopPropagation();
        this.dispatchEvent(dropdownEvent(this.value, this.label));
    }
}